import config from '../../config';

class SubscriptionPreferenceSurveyController {
  constructor(Authentication, PersonaCollection, $rootScope, $timeout, $location) {
    'ngInject';

    Object.assign(this, { Authentication, PersonaCollection, $rootScope, $timeout, $location });
  }
  $onInit() {
    this.user = null;
    this.init();
  }

  async init() {
    if (!config.SUBSCRIPTION_PREFERENCE_SURVEY_ENABLED) {
      return;
    }
    await this.Authentication.userLoaded;
    await this.PersonaCollection.personaCollectionLoaded;
    await this.$timeout(1000);

    this.user = this.Authentication.user;
    this.saveClientFlags = this.Authentication.saveClientFlags;
    this.joinedUsers = this.PersonaCollection.users.filter(user => !!user.joinedAt)
  }

  get locationsCount() {
    return this.PersonaCollection.locations.length;
  }

  get totalUserCount() {
    return this.PersonaCollection.users.length;
  }

  get joinedUserCount() {
    return this.joinedUsers.length;
  }

  get wasFreemiumSelected() {
    return this.Authentication.user.settings.clientFlags.premiumTrialEndPlanLevelSelected === 0;
  }

  onClose() {
    this.$rootScope.forceSubscriptionPreferenceDisplay = false;
  }

  get forceDisplay() {
    return this.$rootScope.forceSubscriptionPreferenceDisplay || false;
  }
}

export default {
  template: `
    <r-subscription-preference-survey ng-if="ctrl.user && ctrl.totalUserCount"
      user="ctrl.user"
      locations-count="ctrl.locationsCount"
      total-user-count="ctrl.totalUserCount"
      joined-user-count="ctrl.joinedUserCount"
      was-freemium-selected="ctrl.wasFreemiumSelected"
      save-client-flags="ctrl.saveClientFlags(flags)"
      force-display="ctrl.forceDisplay"
      on-close="ctrl.onClose()"
      >
    </r-subscription-preference-survey>
    `,
  controller: SubscriptionPreferenceSurveyController,
  controllerAs: 'ctrl',
};
